export function formatFqnForRedshift(fqn: string) {
  const parts = fqn.split('.')
  if (parts.length === 3) {
    let [database, schema, table] = parts
    if (!database.startsWith('"') || !database.endsWith('"')) {
      database = `"${database}"`
    }
    schema = schema.toLowerCase() // FIXME: this preserves previous behaviour, is it right?
    table = table.toLowerCase()
    return [database, schema, table].join('.')
  }
  return fqn.toLowerCase() // FIXME: this preserves previous behaviour, is it right?
}
